import React from 'react';
import owner from '../assets/images/suyog.png';
import storyOne from '../assets/images/story1.png';
import storyTwo from '../assets/images/story2.png';
import storyThree from '../assets/images/story3.png';

const Main: React.FC = () => {
    return (
        <div id="main">
            <section id="intro" class="main">
                <div class="spotlight">
                    <div class="content">
                        <header class="major">
                            <h2>Your Fitness, Our Personal Mission.</h2>
                        </header>
                        <p>Given our personal dedication to overseeing the well-being of everyone who visits our gym, our motto reflects commitment to individual attention and quality fitness experiences. </p>
                    </div>
                    <span class="image"><img src={owner} alt="" /></span>
                </div>
            </section>

            <section id="first" class="main special">
                <header class="major">
                    <h2>Success Stories</h2>
                </header>
                <ul class="features">
                    <li>
                        <span class="image"><img src={storyOne} alt="" width="150" height="150" /></span>
                        <h3>81kg to 66 kgs</h3>
                        <p>100 days transformation.</p>
                    </li>
                    <li>
                        <span class="image"><img src={storyTwo} alt="" width="150" height="150" /></span>
                        <h3>86kg to 66 kgs</h3>
                        <p>100 days transformation.</p>                 </li>
                    <li>
                        <span class="image"><img src={storyThree} alt="" width="150" height="150" /></span>
                        <h3>70kg to 66 kgs</h3>
                        <p>25 days transformation.</p>                    </li>
                </ul>
            </section>

            <section id="second" class="main special">
                <header class="major">
                    <h2>Superman Suyog</h2>
                    <p>Superman Suyog has empowered over 100 clients on their diverse fitness journeys, from weight loss to muscle gain. Trust him to guide you toward your healthiest self.</p>
                </header>
                <ul class="statistics">
                    <li class="style1">
                        <span class="icon solid"></span>
                        <strong>500+</strong> Weight loss journeys
                    </li>
                    <li class="style2">
                        <span class="icon"></span>
                        <strong>500+</strong> Weight gain journeys
                    </li>
                    <li class="style3">
                        <span class="icon solid fa-signal"></span>
                        <strong>100+</strong> Personal trainings
                    </li>
                    <li class="style4">
                        <span class="icon solid fa-laptop"></span>
                        <strong>1000+</strong> Happy clients
                    </li>
                    <li class="style5">
                        <span class="icon fa-gem"></span>
                        <strong>50+</strong> Professional Titles won by clients
                    </li>
                </ul>
                <p class="content">Superman Suyog, known affectionately by his clients for his extraordinary commitment and results-driven approach, has successfully guided over 100 individuals through their personalized fitness journeys. Whether it's shedding unwanted pounds, building muscle, or simply enhancing overall fitness, Suyog has been there every step of the way, providing not just expert guidance but also moral support and motivation. His dedication to helping each client achieve their unique health goals makes him more than just a trainer; he's a true partner in wellness. Trust in Superman Suyog to transform your physical health and empower you on your journey to becoming the best version of yourself.</p>
            </section>

            <section id="cta" class="main special">
                <header class="major">
                    <h2>How to join</h2>
                    <p>
                        Located at Kothari Vatika No.4, Malkapur, Akola<br />
                        Come visit for perfect setting for your fitness journey </p>
                </header>
            </section>

        </div>
    );
}

export default Main;